export var EventBusEvent;
(function (EventBusEvent) {
    EventBusEvent["ToggleSideNav"] = "TOGGLE_SIDE_NAV";
    EventBusEvent["WishlistCounterUpdate"] = "update.wishlist:counter";
    EventBusEvent["CartCounterUpdate"] = "update.header:cart";
    EventBusEvent["CartOverviewUpdate"] = "update.cart:overview";
    EventBusEvent["AddAlerts"] = "ADD_ALERT";
    EventBusEvent["ShowEmptyCart"] = "SHOW_EMPTY_CART";
    EventBusEvent["ToggleDisclaimer"] = "TOGGLE_DISCLAIMER";
    EventBusEvent["UpdateProductMVCOption"] = "UPDATE_PRODUCT_MVC_OPTION";
    EventBusEvent["ReclamationRequestListChange"] = "RECLAMATION_REQUEST_LIST_CHANGE";
    EventBusEvent["ReclamationDrawerToggle"] = "RECLAMATION_DRAWER_TOGGLE";
    EventBusEvent["ReclamationImageGalleryToggle"] = "RECLAMATION_IMAGE_GALLERY_TOGGLE";
    EventBusEvent["ReclamationUploadedPicturesStateChange"] = "RECLAMATION_UPLOADED_PICTURES_STATE_CHANGE";
    EventBusEvent["CheckoutButtonState"] = "CHECKOUT_BUTTON_STATE";
    EventBusEvent["CheckoutButtonDrawerState"] = "CHECKOUT_BUTTON_DRAWER_STATE";
    EventBusEvent["ToggleCategoryOptionsDrawer"] = "TOGGLE_CATEGORY_OPTIONS_DRAWER";
    EventBusEvent["ToggleAlert"] = "TOGGLE_ALERT";
    EventBusEvent["ToggleCheckoutAlert"] = "TOGGLE_CHECKOUT_ALERT";
    EventBusEvent["ShowLexiconDescription"] = "SHOW_LEXICON_DESCRIPTION";
    EventBusEvent["EditAddressDrawerToggle"] = "EditAddressDrawerToggle";
})(EventBusEvent || (EventBusEvent = {}));
